import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';

interface PageLoadingProps {
  content?: string;
}

export const PageLoading = ({ content }: PageLoadingProps) => {
  return (
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        my={5}
        gap={4}
      >
        <CircularProgress color="inherit" />
        <Typography variant="subtitle2">{content || 'Data Loading...'}</Typography>
      </Box>
    </Backdrop>
  );
};
